<template>
  <v-container grid-list-md fluid>
    <!-- <code>{{parametros}}</code> -->
      <v-layout row wrap >
        <v-flex md12 >
          <v-card>
            <v-toolbar  dense primary-title>
              <v-toolbar-title>{{$t("view.menu.catalogosGenerales.sub.parametros.text")}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="view.elem.showForm = !view.elem.showForm">
                <v-icon>{{ view.elem.showForm ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
              </v-btn>
            </v-toolbar>
            <v-slide-y-transition>
              <div v-show="view.elem.showForm">
                <v-card-text>
                  <v-form>
                    <v-layout row v-if="view.action.submit.busy">
                      <vue-content-loading :width="450" :height="158">
                        <rect x="0" y="0" rx="4" ry="4" width="53" height="10" />
                        <rect x="0" y="15" rx="4" ry="4" width="442" height="34" />
                        <rect x="0" y="64" rx="4" ry="4" width="53" height="10" />
                        <rect x="0" y="79" rx="4" ry="4" width="442" height="34" />
                        <rect x="0" y="128" rx="10" ry="10" width="80" height="30" />
                      </vue-content-loading>
                    </v-layout>
                      <v-flex d-flex md6 tag="h3" class="headline">{{$t('view.parametros.ventanaHorariaConversion.label')}}</v-flex>
                    <v-layout row>
                      <v-flex d-flex md4>
                        <v-menu
                          ref="menuHorarioConversionInicio"
                          :close-on-content-click="false"
                          v-model="view.menuHorarioConversionInicio"
                          :nudge-right="40"
                          :return-value.sync="$v.parametros.horarioConversionInicio.$model"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          max-width="290px"
                          min-width="290px">
                          <v-text-field
                            slot="activator"
                            v-model="$v.parametros.horarioConversionInicio.$model"
                            :label="$t('view.global.common.desde')"
                            prepend-icon="access_time"
                            :error-messages="getFirstErrorDescription($v.parametros.horarioConversionInicio)"
                            readonly>
                          </v-text-field>
                          <v-time-picker 
                            v-if="view.menuHorarioConversionInicio"
                            @change="$refs.menuHorarioConversionInicio.save(parametros.horarioConversionInicio)" 
                            
                            v-model="$v.parametros.horarioConversionInicio.$model" >
                          </v-time-picker>
                        </v-menu>
                      </v-flex>
                      
                      <v-flex d-flex md4 >
                        <v-menu
                          ref="menuHorarioConversionFin"
                          :close-on-content-click="false"
                          v-model="view.menuHorarioConversionFin"
                          :nudge-right="40"
                          :return-value.sync="$v.parametros.horarioConversionFin.$model"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          max-width="290px"
                          min-width="290px">
                          <v-text-field
                            slot="activator"
                            v-model="$v.parametros.horarioConversionFin.$model"
                            :label="$t('view.global.common.hasta')"
                            prepend-icon="access_time"
                            :error-messages="getFirstErrorDescription($v.parametros.horarioConversionFin)"
                            readonly>
                          </v-text-field>
                          <v-time-picker 
                            v-if="view.menuHorarioConversionFin"
                            @change="$refs.menuHorarioConversionFin.save(parametros.horarioConversionFin)" 
                            v-model="$v.parametros.horarioConversionFin.$model" >
                          </v-time-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex d-flex md4 child-flex>
                        <div class="text-xs-center">
                          <label>{{$t('view.parametros.dias.label')}}</label>
                          <circle-slider
                            v-model="$v.parametros.dias.$model"
                            circle-color="gray"
                            progress-color="blue"
                            knob-color="blue"
                            :side="150"
                            :min="1"
                            :max="30"
                            :circle-width-rel="20"
                            :progress-width-rel="10"
                            :knob-radius="10"
                          > </circle-slider>
                          <div>{{parametros.dias}}</div>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout md8>
                      <v-flex d-flex md8 tag="h3" class="headline">{{$t('view.parametros.ventanaHorariaDescarga.label')}}</v-flex>
                    </v-layout>
                    <v-layout >
                      <v-flex d-flex md3>
                        <v-menu
                          ref="menuHorarioDescargaInicio"
                          :close-on-content-click="false"
                          v-model="view.menuHorarioDescargaInicio"
                          :nudge-right="40"
                          :return-value.sync="$v.parametros.horarioDescargaInicio.$model"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          max-width="290px"
                          min-width="290px">
                          <v-text-field
                            slot="activator"
                            v-model="$v.parametros.horarioDescargaInicio.$model"
                            :label="$t('view.global.common.desde')"
                            prepend-icon="access_time"
                            :error-messages="getFirstErrorDescription($v.parametros.horarioDescargaInicio)"
                            readonly>
                          </v-text-field>
                          <v-time-picker 
                            v-if="view.menuHorarioDescargaInicio"
                            @change="$refs.menuHorarioDescargaInicio.save(parametros.horarioDescargaInicio)" 
                            v-model="$v.parametros.horarioDescargaInicio.$model" >
                          </v-time-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex d-flex md3>
                        <v-menu
                          ref="menuHorarioDescargaFin"
                          :close-on-content-click="false"
                          v-model="view.menuHorarioDescargaFin"
                          :nudge-right="40"
                          :return-value.sync="$v.parametros.horarioDescargaFin.$model"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          max-width="290px"
                          min-width="290px">
                          <v-text-field
                            slot="activator"
                            v-model="$v.parametros.horarioDescargaFin.$model"
                            :label="$t('view.global.common.hasta')"
                            prepend-icon="access_time"
                            :error-messages="getFirstErrorDescription($v.parametros.horarioDescargaFin)"
                            readonly>
                          </v-text-field>
                          <v-time-picker 
                            v-if="view.menuHorarioDescargaFin"
                            @change="$refs.menuHorarioDescargaFin.save(parametros.horarioDescargaFin)" 
                            v-model="$v.parametros.horarioDescargaFin.$model" >
                          </v-time-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex d-flex md3>
                        <v-text-field 
                            :label="$t('view.parametros.idRemitente.label')" 
                            class="text-xs-center"
                            v-model="$v.parametros.summiterID.$model"
                            :error-messages="getFirstErrorDescription($v.parametros.summiterID)"
                          ></v-text-field>
                      </v-flex>
                      <v-flex d-flex md3>
                        <v-text-field
                          :type="view.elem.button.numeroIntentos.type"
                          :label="$t('view.parametros.numeroIntentos.label')"
                          v-model="$v.parametros.numeroIntentos.$model"
                          :min="view.elem.button.numeroIntentos.min"
                          :max="view.elem.button.numeroIntentos.max"
                          :error-messages="getFirstErrorDescription($v.parametros.numeroIntentos)">
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex d-flex md6 >
                        <v-card>
                          <v-toolbar dense color="secondary" dark>
                            <v-toolbar-title>{{$t("view.global.common.buzon")}}</v-toolbar-title>
                          </v-toolbar>
                          <v-card-text>
                            <v-flex d-flex>
                              <v-text-field
                                :placeholder="$t('view.global.common.url')"
                                prefix="sftp://"
                                v-model="$v.parametros.urlBuzonSFTP.$model"
                                :error-messages="getFirstErrorDescription($v.parametros.urlBuzonSFTP)"
                                :label="$t('view.global.common.url')" >
                              </v-text-field>
                            </v-flex>
                            <v-flex d-flex>
                            <v-text-field
                              type="number"
                              v-model="$v.parametros.puertoBuzonSFTP.$model"
                              :error-messages="getFirstErrorDescription($v.parametros.puertoBuzonSFTP)"
                              :label="$t('view.comercio.puerto')" 
                              >
                            </v-text-field>
                          </v-flex>
                            <v-flex d-flex>
                              <v-text-field
                                v-model="$v.parametros.usuarioBuzonSFTP.$model"
                                :error-messages="getFirstErrorDescription($v.parametros.usuarioBuzonSFTP)"
                                :label="$t('view.global.common.usuario')" >
                              </v-text-field>
                            </v-flex>
                            <v-flex d-flex>
                              <v-text-field
                                v-model="$v.parametros.passwordBuzonSFTP.$model"
                                type="password"
                                :error-messages="getFirstErrorDescription($v.parametros.passwordBuzonSFTP)"
                                :label="$t('view.global.common.contrasena')" >
                              </v-text-field>
                            </v-flex>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex d-flex md6>
                        <v-card>
                          <v-toolbar dense color="secondary" dark>
                            <v-toolbar-title>{{$t("view.parametros.encriptacion.label")}}</v-toolbar-title>
                          </v-toolbar>
                          <v-card-text>
                            <v-layout row>
                            <v-flex d-flex md6>
                              <v-switch  
                              input-value="true" 
                              color="primary"
                              :label="`${$t('view.parametros.seguridadHabilitadaZIP.label')} ${$v.parametros.seguridadHabilitadaZIP.$model ? 'on' : 'off'}`" 
                              v-model="$v.parametros.seguridadHabilitadaZIP.$model" >
                              </v-switch>
                            </v-flex>
                            <v-flex d-flex md6 >
                              <v-text-field
                                :disabled="!$v.parametros.seguridadHabilitadaZIP.$model"
                                v-model="parametros.passwordZIP"
                                type="password"
                                :error-messages="getFirstErrorDescription($v.parametros.passwordZIP)"
                                :label="$t('view.parametros.passwordZIP.label')" >
                              </v-text-field>
                            </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-card-text>
                
                <v-card-actions  >
                    <v-spacer></v-spacer>
                    <v-tooltip v-show="view.elem.button.audit.visible && $userPermission.hasPermission('ROLE_ACCESO_AUDITORIA')" top>
                      <v-btn 
                        @click="showAudit()" 
                        :loading="view.action.submit.busy" 
                        color="primary" dark
                        icon slot="activator" large >
                        <v-icon>storage</v-icon>
                      </v-btn>
                      <span>{{$t('view.global.common.auditoria')}}</span>
                    </v-tooltip>
                    <v-tooltip v-show="view.elem.button.audit.visible && $userPermission.hasPermission('ROLE_MODIFICAR_PARAMETROS')" top>
                      <v-btn 
                        @click="submit()" 
                        :loading="view.action.submit.busy" 
                        :disabled="form.$state.isDisableButtonSubmit()"
                        color="primary"  dark 
                        icon slot="activator" large>
                        <v-icon>check</v-icon>
                      </v-btn>
                      <span>{{$t('view.global.common.update')}}</span>
                    </v-tooltip>
                    <div class="text-xs-center">
                    </div>
                </v-card-actions>
              </div>
            </v-slide-y-transition>  
          </v-card>
        </v-flex>
      </v-layout>
      <auditoria ref="auditModal"></auditoria>
  </v-container>
</template>
<script>
import {ParametrosModel} from "@/models/generales/parametros";
import ParametrosAPI from "@/services/generales/parametros";
import {required, requiredIf, maxLength} from "vuelidate/lib/validators";
import {allValidatorMethods} from "@/helpers/vuelidate";
import {urlFTP, alphaNumDot} from '@/helpers/vuelidate/validators'
import VueContentLoading from 'vue-content-loading';
import Auditoria from "@/components/auditoria/Auditoria";
import ParametrosState from '@/views/generales/parametros/parametros-states';
import * as R from "ramda";
import tippy from 'tippy.js';
import {getErrors,getBusinessCode,getResponseDTO} from '@/helpers/http-response-handler';
import {Slider} from 'element-ui'; 
import {EventBus} from '@/events/event-bus';
import * as events from '@/constants/event-names';




//Element's Settings
const button = {
  submit:{
    enable:true
    , text:""
    , class:{
      current:""
      , save:"button__icon icon fa fa-plus"
      , update:"button__icon icon fa fa-check"
    }
    , data:{
       id: 0
       , title:{
        current:"",
        save:"Guardar",
        update:"Actualizar"
       }
    }
  }
  , numeroIntentos:{ type: "number", min: "3", max: "10" }
  , clear:{
    visible:false
  }
  , audit:{
    visible:false
  }
  
};
//Action's state
const action = {
  submit:{
    busy:false
  }
};

//Initial Model
//const parametros = new ParametrosModel();
//Helpers
function evaluateModelChangedMethodResult(data){
  if(!data && typeof data === "boolean"){
  return data
  }

  if(data && typeof data === "object"){
  return data.length>=1;
  } 
}
const modelIsModified = R.curry((model)=>R.compose(evaluateModelChangedFlag,model.changed));

export default {
  name: "Parametros",
  head:{
    title:function(){
      return {
        inner       : this.view.title
        , separator : '|'
        , complement: this.$t("view.home.system.initials")
      }
    }
  }
  , data() {
    let _locale = this.$store.language;
    return {
      locale: _locale
      , parametros : undefined
      , view:{
        title:"Parámetros del Sistema"
        , messageError : 'Mensaje Default'
        , action
        , elem:{
          button
          , menuHorarioConversionInicio : false
          , menuHorarioConversionFin : false
          , menuHorarioDescargaInicio : false
          , menuHorarioDescargaFin : false
          , showForm:true
        }
      }
      , check:true
      , form : new Object()
    };
  }
  , methods: {
    ...allValidatorMethods
    ,handleResponse(response){
      const code = getBusinessCode(response);
      if(code == 'OK')
      {
        EventBus.$emit(events.MESSAGES, {type:code});
        // this.$parent.showToastr( 'OK' );
        return true;
      }
      else 
      {
        if(response != false)
          EventBus.$emit(events.MESSAGES, {type:'error',message: getErrors('Parametros',this.view.messageError,code)});
          // this.$parent.showToastrError(this.getErrorsUsuarios('Mensaje Default',code),code);
        return false;
      }
    }
    , getErrorsParametros(defaultMessage, message, code){
      return getErrors('Parametros',defaultMessage, message, code);
    }
    , async submit(){

      try{
        const respuesta = await this.form.$state.submit(this.parametros);
        console.log(respuesta);
        if(this.handleResponse(respuesta)){
          this.parametros.clave = 1;
          this.form.$setState('editing',respuesta.data.results.parametros);
        }
        
      }catch(error){
      }
    }
    , askForClear(){
      this.form.$state.askForClear();
    }
    , async showAudit(id=this.parametros.clave,dataDescripcion=this.$t("view.menu.catalogosGenerales.sub.parametros.text")){
        this.$refs.auditModal.loadAudit({clave:1,tabla:'TParametros',descripcion:dataDescripcion,revision:null});
    }
    , async loadParametros(idParametros){
      try{
        const response = await ParametrosAPI.get({clave:idParametros});
        const {data:{results:{parametros}}} = response;
        this.form.$setState('editing',parametros)
      }catch(error){
      }
    }
  }
  , computed:{
    submitClass(){
      return this.view.elem.button.submit.class.current
    }
    , horarioConversion(){
      return this.formulario.horarioConversion
    }
    , horarioDescarga(){
      return this.formulario.horarioDescarga
    }
    
  }
  , validations:{    
    parametros:{
      dias:{
        required
        , maxLength : maxLength(255)
      }
      , horarioConversionInicio: {
        required
      }
      , horarioConversionFin: {
        required
      }
      , horarioDescargaInicio: {
        required
      }
      , horarioDescargaFin: {
        required
      }
      , summiterID:{
        required
        , alphaNumDot
      }
      , urlBuzonSFTP:{
        required
        
      }
      , usuarioBuzonSFTP:{
        required
      }
      , passwordBuzonSFTP:{
        required
      }
      , puertoBuzonSFTP:{
        required
      }
      , numeroIntentos:{
        required
      }
      , passwordZIP:{
        required:requiredIf(function(model){
            return this.$v.parametros.seguridadHabilitadaZIP.$model
          })
      }
      ,seguridadHabilitadaZIP:{
        required
      }
    //   , horarioDescarga:{
    //     required
    //     , maxLength : maxLength(255)
    //   }
    }
  }
  , components: {
    VueContentLoading
    , Auditoria
    , Slider
  }
  // Instance Lifecycle Hooks
  , async created(){
    this.form = new ParametrosState(this);
    this.form.$setState('initial');
    // Object.setPrototypeOf(this.state, new states.InitialState(this));
    
  }
  , mounted(){
    this.$nextTick(function(){
      tippy('.btn', {
            arrow: true,
            arrowType: 'round',
            size: 'large',
            animation: 'scale'
          });
    });
    // this.$parent.appJQueryConfigMethod();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
.v-text-field__prefix {
    width: 50px !important;
    text-align: right;
    padding-right: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/generales/parametros/Parametros.vue